import { Injectable, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs/Observable';
import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';
import { Service } from 'app/admin/services/service.model';
import { ClientService, ServiceValue } from 'app/entities/details/services/client-service.model';

import { plainToClass } from 'class-transformer';


/**
 * Service to perform admin service functionalities.
 *
 * @author mohit.khurana@vernuso.com (Mohit Khurana)
 */
@Injectable()
// @todo This class is to be updated once REST is available
export class ServiceService {
    selectedAdminCategory: EventEmitter<ClientService> = new EventEmitter();

    constructor(private requestService: ObservableRequestService) { }

    setSelectedServiceCategory(selectedAdminCategory: ClientService) {
        this.selectedAdminCategory.emit(selectedAdminCategory);
    }

    // Service method to add new admin service.
    addNewAdminService(addServiceData: Service): Observable<any> {
        return this.requestService.postRequest(ConstantsService.ADD_ADMIN_SERVICE,
            JSON.stringify(addServiceData),
            this.requestService.getJSONContentType()
        );
    }

    deleteAdminService(serviceId: number): Observable<any> {
        return this.requestService.deleteRequest(
            ConstantsService.DELETE_ADMIN_SERVICE,
            this.requestService.serialize({id : serviceId}),
            this.requestService.getFormEncodedContentType());
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/services/service.service.ts